import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { AppLanguages } from '../../../../../shared/constants/enums'
import { AppLanguageService } from '../../../../services/app-language.service'

@Component({
    selector: 'app-dashboard-layout-topbar-lang-change',
    templateUrl: './dashboard-layout-topbar-lang-change.component.html',
    styleUrls: ['./dashboard-layout-topbar-lang-change.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class DashboardLayoutTopbarLanguageChangeComponent implements OnInit {
    languages = Object.values(AppLanguages)
    languageForm!: FormGroup

    constructor(
        private fb: FormBuilder,
        private appLanguageService: AppLanguageService
    ) {}

    ngOnInit(): void {
        const appLanguage = this.appLanguageService.getAppLanguage()
        this.languageForm = this.fb.group({
            lang: [appLanguage]
        })
    }

    onLangChange(lang: AppLanguages): void {
        this.appLanguageService.setAppLanguage(lang)
    }
}
